import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface ConfirmActionModalProps {
  show: boolean;
  title: string;
  body: React.ReactNode;
  confirmLabel?: string;
  confirmVariant?: string;
  busy?: boolean;
  requireTypedConfirmation?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  show,
  title,
  body,
  confirmLabel = "Confirm",
  confirmVariant = "danger",
  busy = false,
  requireTypedConfirmation,
  onConfirm,
  onCancel,
}) => {
  const [typedValue, setTypedValue] = useState("");

  useEffect(() => {
    if (!show) setTypedValue("");
  }, [show]);

  const confirmationMet =
    !requireTypedConfirmation ||
    typedValue.trim().toLowerCase() === requireTypedConfirmation.trim().toLowerCase();

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
        {requireTypedConfirmation && (
          <Form.Group className="mt-3" controlId="confirm-action-typed-confirmation">
            <Form.Label>
              Type <strong>{requireTypedConfirmation}</strong> to confirm.
            </Form.Label>
            <Form.Control
              type="text"
              value={typedValue}
              autoComplete="off"
              onChange={(e) => {
                setTypedValue(e.target.value);
              }}
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} disabled={busy || !confirmationMet}>
          {busy ? "Please wait…" : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
